
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/CustomerLayout.js';
import * as General from '../General/General.js';
import * as ReactDOM from 'react-router-dom';
import PN from 'persian-number'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { BiFilter } from "react-icons/bi";
import { trackPromise } from 'react-promise-tracker';
// import * as BiIcon from "react-icons/bi"
import axios from 'axios';
import styled from "styled-components"



const ErrorMessageClass = styled.div`

	color: rgba(180, 56, 56);
	// color: white !important;
	font-weight: bold !important;
	// font-size: 20px !important;
	position: absolute;
	top: 25vh;
	// right: 30%;
	transform: translate(-0%, -0%);
	z-index: 2;
	// width: 100vh;
	padding: 30px;
	text-align: center !important;
	border-top-right-radius: 20px;
	border-bottom-left-radius: 20px;

`


const PaymentFailed = () => {

    const toaster = rsuite.useToaster();
    const CityRef = useRef()

    const [BasketId, setBasketId] = React.useState(General.GuidEmpty())
    const [TotalPrice, setTotalPrice] = React.useState(0)
    const [BasketCode, setBasketCode] = React.useState()
    const [PayError, setPayError] = React.useState()
    const [RecieptNo, setRecieptNo] = React.useState()





    const Bind = () => {
        var RequestOptions = {
            data: {
            },
            url: General.ApiRoute() + "/FinalPayment/GetPaymentResult",
            method: "get",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',

            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = [];
                    var itemCount = 0;
                    if (result.data.children.length > 0) {
                        setBasketId(result.data.id)
                        setTotalPrice(result.data.totalPrice)
                        setBasketCode(result.data.code)
                        setPayError(result.data.payError)
                        setRecieptNo(result.data.recieptNo)


                    }



                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )

    }

    React.useEffect(() => {
        Bind();

    }, [])


    return (
        <Layout title={'خطا در پرداخت سبد خرید :   ' + BasketCode} className="hide">

            <rsuite.Row className="p-3">

                <rsuite.Col xs={24} sm={24} md={24} >
                    <ErrorMessageClass className={isMobile ? "Font13" : "Font20"}>

                        <b>
                            خطا در تکمیل خرید - سبد خرید : {BasketCode}

                        </b>
                        <br />
                        {PayError}
                        <br />
                        {RecieptNo != "" ?
                            <>در صورت کسر مبلغ و عدم برگشت آن تا 72 ساعت با داشتن کد پیکیری  ( {RecieptNo} )  و شماره سبد خرید با پشتیباتی تماس بگیرید</>
                            :
                            <></>
                        }
                    </ErrorMessageClass>

                </rsuite.Col>

            </rsuite.Row >
        </Layout >
    )
}

export default PaymentFailed;